

export default {
    totalLeaseSuppliesOrders: [],
    leaseSuppliesOrders: [],
  
}
